// extracted by mini-css-extract-plugin
export var logo = "styles-module--logo--zr3c9";